import dayjs from 'dayjs';

function isSelected(day, sel) {
  return sel?.isSame(day, 'day');
}

export function beforeToday(day) {
  return day.isBefore(dayjs(), 'day');
}

function isToday(day) {
  return day.isSame(dayjs(), 'day');
}

export function isValidSpecialDay(day, startDate, endDate) {
  return day.isAfter(startDate) && day.isBefore(endDate);
}

export function isValidEndCalendarDayDay(day) {
  return day.diff(dayjs(new Date()), 'days') <= 60;
}

export function isNotInMonth(day, month) {
  return !day.isSame(month, 'month');
}

export function priceStyles(day, sel, month) {
  if (isNotInMonth(day, month)) return 'hidden';
  if (beforeToday(day)) return 'hidden';
  if (isSelected(day, sel)) return 'flex';
  if (isToday(day)) return 'text-blue-600 rounded-lg cursor-pointer flex';
  return 'text-gray-600 flex';
}

export default function dayStyles(
  day,
  sel,
  month,
  isTodayOverride = null,
  afterToday = null,
  disabled = false,
) {
  if (isNotInMonth(day, month) && !afterToday)
    return 'bg-transparent text-gray-400';
  if (beforeToday(day) || disabled) return 'bg-gray-100 text-gray-400';
  if (afterToday && afterToday(day)) {
    if (isNotInMonth(day, month)) {
      return 'bg-transparent text-gray-400 line-through';
    } else {
      return 'bg-gray-100 text-gray-400 line-through';
    }
  }
  if (isSelected(day, sel))
    return 'transform hover:scale-105 transition bg-blue-400 text-white hover:bg-blue-500 cursor-pointer';
  if (
    (isTodayOverride && isTodayOverride(day)) ||
    (!isTodayOverride && isToday(day))
  )
    return 'transform hover:scale-105 transition bg-white text-blue-600 rounded-lg ring-inset ring-2 ring-blue-300 hover:bg-blue-300 hover:text-white cursor-pointer';
  return 'transition ease-in-out bg-gray-100 transform hover:scale-105 hover:border-blue-400 hover:bg-blue-300 hover:text-white text-gray-600 ring-inset border-2 border-transparent cursor-pointer';
}

export function dayStylesAnyDay(day, sel, month) {
  if (isNotInMonth(day, month)) return 'bg-transparent text-gray-400';
  if (isSelected(day, sel))
    return 'transform hover:scale-105 transition bg-blue-400 text-white hover:bg-blue-500 cursor-pointer';
  if (isToday(day))
    return 'transform hover:scale-105 transition bg-white text-blue-600 rounded-lg ring-inset ring-2 ring-blue-300 hover:bg-blue-300 hover:text-white cursor-pointer';
  return 'transition ease-in-out bg-gray-100 transform hover:scale-105 hover:border-blue-400 hover:bg-blue-300 hover:text-white text-gray-600 ring-inset border-2 border-transparent cursor-pointer';
}

export function specialCalendarDayStyles(day, sel, month, startDate, endDate) {
  if (isNotInMonth(day, month)) return 'bg-transparent text-gray-400';
  if (beforeToday(day)) return 'bg-gray-100 text-gray-400';
  if (isSelected(day, sel))
    return 'transform hover:scale-105 transition bg-blue-400 text-white hover:bg-blue-500 cursor-pointer';
  if (isToday(day))
    return 'transform hover:scale-105 transition bg-white text-blue-600 rounded-lg ring-inset ring-2 ring-blue-300 hover:bg-blue-300 hover:text-white cursor-pointer';
  if (!isValidSpecialDay(day, startDate, endDate))
    return 'bg-gray-100 text-gray-400';
  return 'transition ease-in-out bg-gray-100 transform hover:scale-105 hover:border-blue-400 hover:bg-blue-300 hover:text-white text-gray-600 ring-inset border-2 border-transparent cursor-pointer';
}

export function createListingEndCalendarDayStyles(
  day,
  sel,
  month,
  listingMode,
) {
  if (isNotInMonth(day, month)) return 'bg-transparent text-gray-400';
  if (beforeToday(day)) return 'bg-gray-100 text-gray-400';
  if (isSelected(day, sel))
    return 'transform hover:scale-105 transition bg-blue-400 text-white hover:bg-blue-500 cursor-pointer';
  if (isToday(day))
    return 'transform hover:scale-105 transition bg-white text-blue-600 rounded-lg ring-inset ring-2 ring-blue-300 hover:bg-blue-300 hover:text-white cursor-pointer';
  if (!isValidEndCalendarDayDay(day) && listingMode !== 'DIRECT')
    return 'bg-gray-100 text-gray-400';
  return 'transition ease-in-out bg-gray-100 transform hover:scale-105 hover:border-blue-400 hover:bg-blue-300 hover:text-white text-gray-600 ring-inset border-2 border-transparent cursor-pointer';
}
